// A session seed keeps new IDs disjoint from counters restored from prior loads.
const threadSeed = Math.random().toString(36).slice(2, 8)
let threadCounter = 0

export function nextThreadId(): string {
  threadCounter += 1
  return `t_${threadSeed}_${threadCounter}`
}
